<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Aportes - Listar</strong>
          </CCardHeader>
          <CCardBody>
            <b-row>
         

                <b-col sm="12" md="5">
                 
                </b-col>

                <b-col sm="12" md="2">
                
                </b-col>

                <b-col sm="12" md="2">
           
                </b-col>

                
                <b-col sm="6" md="3">
                  <b-form-group>
                    <b-input-group>
                    <b-form-input v-model="search" class="form-control"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" @click="ListContribution"><b-icon icon="search"></b-icon></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  </b-form-group>
                </b-col>

           
            </b-row>

            <div class="table-responsive mt-3 height-table">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="3%" class="text-center">#</th>
                    <th width="8%" class="text-center">Fecha</th>
                    <th width="40%" class="text-center">Socio</th>
                    <th width="10%" class="text-center">M. Pago</th>
                    <th width="10%" class="text-center">N° Boleta</th>
                    <th width="8%" class="text-center">Total</th>
                    <th width="7%" class="text-center">Usuario</th>
                    <th width="7%" class="text-center">Estado</th>
                    <th width="7%" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="it">
                  <tr>
                    <td class="text-center">{{ it + 1 }}</td>
                    <td class="text-center"> {{ item.broadcast_date  }}</td>
                    <td class="text-left"> {{ item.partner_name + " - "+ item.partner_document_number  }}</td>
                    <td class="text-left"> {{ NameMethodPayment(item.payment_method)  }}</td>
                    <td class="text-left"> {{ item.number  }}</td>
                    <td class="text-right"> {{ item.total  }}</td>
                    <td class="text-left"> {{ item.user  }}</td>
                    <td class="text-center">
                        <b-badge v-if="item.state == 1" variant="success">Activo</b-badge>
                        <b-badge v-if="item.state == 0" variant="danger">Anulado</b-badge>
                    </td>
                    <td class="text-center">
                      <b-dropdown bloque size="sm" text="Acciones" right>
                        <b-dropdown-item v-if="Permission('ContributionView')" @click="ViewContribution(item.id_contribution)" >Ver</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-row class="mt-4">
              <b-col md="8">
                <b-pagination v-model="currentPage" v-on:input="ListContribution" :total-rows="rows" :per-page="perPage" align="center" ></b-pagination>
              </b-col>
              <b-col md="4 text-center">
                <p>Pagina Actual: {{ currentPage }}</p>
              </b-col>
            </b-row>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import CodeToName from "@/assets/js/CodeToName";
var moment = require("moment");
export default {
  name: "UsuarioList",
  props: ["id_partner"],
  components:{
    vSelect,
  },
  data() {
    return {
      module:'AccumulatedContribution',
      perPage: 15,
      currentPage: 1,
      rows: 0,
      data_table: [],
      
      id_partner:'',
      to:moment(new Date()).local().format("YYYY-MM-DD"),
      from:moment().subtract(30, 'days').local().format("YYYY-MM-DD"),
      search: "",
      partners: [],
      partner:null,
      errors:{
        to:false,
        from:false,
      }
    };
  },
  mounted() {
    this.ListContribution();
  },
  methods: {
    ListContribution,
    EditContribution,
    ViewContribution,
    ConfirmDeleteContribution,
    DeleteContribution,
    Permission,

    SearchPartnes,
    NameTwistType,
    NameMethodPayment,

  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
    id_establishment: function () {
      let establishment = window.localStorage.getItem("id_establishment");
      establishment = JSON.parse(je.decrypt(establishment));
      return establishment;
    }
  },
};

function NameMethodPayment(code) {
return CodeToName.NameMethodPayment(code);
}

function NameTwistType(code) {
  let name = '';
  switch (code) {
    case '1': name = 'Sepelio'; break;
    case '2': name = 'Liquidación de Aportes'; break;
    case '3': name = 'Gasto Administrativo'; break;
    case '4': name = 'Prestamo Ordinario'; break;
  }
  return name;
}

function SearchPartnes(search, loading) {
  
   let me = this;
    let url = this.url_base + "search-partner/" + search;
    if (search !== "") {
      loading(true);
      axios({
        method: "GET",
        url: url,
      }).then(function (response) {
            me.partners = response.data;
            loading(false);
      })
    }
}

function ListContribution() {

  let id_partner = je.decrypt(this.id_partner);
  let search = this.search == "" ? "all" : this.search;

  let me = this;
  let url = this.url_base + "accumulated-contribution/list-by-partner/" + id_partner +"/"+ search + "?page=" + this.currentPage;

  axios({
    method: "GET",
    url: url,
    headers: { token: this.token, module: this.module, role: 5},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.total;
        me.data_table = response.data.result.data;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// Editar usuario
function EditContribution(id_contribution) {
  this.$router.push({
    name: "ContributionEdit",
    params: { id_contribution: je.encrypt(id_contribution) },
  });
}

// Ver Usuario
function ViewContribution(id_contribution) {
  this.$router.push({
    name: "ContributionView",
    params: { id_contribution: je.encrypt(id_contribution) },
  });
}

// Confirmar eliminar
function ConfirmDeleteContribution(id_contribution) {
  Swal.fire({
    title: "Esta seguro de eliminar el aporte?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeleteContribution(id_contribution);
    }
  });
}

// eliminar usuario
function DeleteContribution(id_contribution) {
  let me = this;
  let url = this.url_base + "contribution/delete/" + id_contribution;
  axios({
    method: "delete",
    url: url,
    headers: {token: this.token, module: this.module,role: 4,},
  })
    .then(function (response) {
       if (response.data.status == 200) {
        const index = me.data_table.map(item => item.id_contribution).indexOf(response.data.result.id_contribution);
        me.data_table.splice(index, 1);
        Swal.fire({ icon: 'success', text: response.data.message, timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>
